const PageNotFound = () => {
  return <div>The page you are searching is not found</div>;
};

export default PageNotFound;
